import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from './redux/actions';
import { Tabs, Form, Input, Button, message, Checkbox } from 'antd';
import { common } from '../../utils';
const TabPane = Tabs.TabPane;
export class Register extends Component {
  state = {
    codeTxt: '获取验证码',
    phone: '',
    isAgree: false,
  };
  static propTypes = {
    common: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!this.state.isAgree) {
        message.warn('请接受用户协议之后注册');
        return;
      }
      values.IsLogin = 1;
      values.RePeat = 1;
      values.RegisterType = 2;
      values.RegisterProtolVaild = this.state.isAgree ? 1 : 0;
      if (!err) {
        this.props.actions.fetchRegister(values).then(res => {
          if (res.SuccessResponse) {
            //message.success(res.Message, ",请登录");
            this.props.actions.fetchStudentBasics({ StuID: res.Data.StuID }).then(_res => {
              this.props.history.push('/center');
            });
          } else {
            message.error(res.Message);
          }
        });
      }
    });
  };
  onAgreeChange(e) {
    this.setState({
      isAgree: e.target.checked,
    });
  }
  getCode() {
    if (this.state.phone.trim() === '') {
      message.warn('手机号码不能为空');
      return;
    }
    if (common.checkPhone(this.state.phone)) {
      let seconds = 60;
      this.setState({
        codeTxt: '发送中...',
      });
      this.props.actions.fetchGetPhoneCode({ Phone: this.state.phone }).then(res => {
        if (res.SuccessResponse) {
          message.success(res.Message);
          let timer = setInterval(() => {
            if (seconds > 0) {
              this.setState({
                codeTxt: `${seconds--}秒`,
              });
            } else {
              clearInterval(timer);
              this.setState({
                codeTxt: '获取验证码',
              });
            }
          }, 1000);
        } else {
          this.setState({
            codeTxt: '获取验证码',
          });
        }
      });
    } else {
      message.warn('请输入正确的手机号');
    }
  }
  render() {
    const ConfigInfo = this.props.common.fetchConfigInfo;
    const operations = (
      <span className="goLogin">
        已有账号
        <b
          onClick={() => {
            this.props.history.push('/login');
          }}
        >
          去登录 >
        </b>
      </span>
    );
    const { getFieldDecorator } = this.props.form;
    const { codeTxt, isAgree, CompanyName } = this.state;
    return (
      <div className="common-register">
        <div className="register-view">
          <img src={require('../../images/login_img.png')} alt="" />
          <Tabs defaultActiveKey="1" className="register-tabs" tabBarExtraContent={operations}>
            <TabPane tab="注册" key="1">
              <Form onSubmit={this.handleSubmit} className="register-form">
                <Form.Item>
                  {getFieldDecorator('Phone', {
                    rules: [
                      { required: true, message: '请输入手机号' },
                      {
                        pattern: '^[1][3,4,5,6,7,8,9][0-9]{9}$',
                        message: '请输入正确的手机号',
                      },
                    ],
                  })(
                    <Input
                      placeholder="手机号"
                      onChange={e =>
                        this.setState({
                          phone: e.target.value,
                        })
                      }
                      style={{ height: 40 }}
                    />,
                  )}
                </Form.Item>
                <Form.Item>
                  {getFieldDecorator('Code', {
                    rules: [{ required: true, message: '请输入验证码' }],
                  })(
                    <Input
                      placeholder="验证码"
                      style={{ height: 40 }}
                      suffix={
                        <p
                          className="getCode"
                          onClick={() => {
                            if (codeTxt === '获取验证码') {
                              this.getCode();
                            }
                          }}
                        >
                          {codeTxt}
                        </p>
                      }
                    />,
                  )}
                </Form.Item>
                <Form.Item>
                  <Button type="theme" htmlType="submit" className="register-form-button">
                    注册
                  </Button>
                  {ConfigInfo && (
                    <Checkbox
                      defaultChecked={isAgree}
                      className="agreement"
                      onChange={this.onAgreeChange.bind(this)}
                    >
                      我已接受{ConfigInfo.HeaderName}
                      <span
                        onClick={e => {
                          e.stopPropagation();
                          this.props.history.push('/agreement');
                        }}
                      >
                        用户协议
                      </span>
                    </Checkbox>
                  )}
                </Form.Item>
              </Form>
            </TabPane>
          </Tabs>
        </div>
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    common: state.common,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form.create({ name: 'normal_register' })(Register));



// WEBPACK FOOTER //
// ./src/features/common/Register.js